var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('title-container-component',{attrs:{"title":"Tools"}},[_c('v-virtual-scroll',{staticStyle:{"height":"100%","overflow-y":"auto","overflow-x":"hidden"},attrs:{"items":_vm.listOfActionsGroupBy3,"item-height":1100,"height":"500"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-row',{staticClass:"d-flex justify-center"},[_c('v-col',{attrs:{"cols":"1"}},[(
            item[0] !== undefined &&
            !(
              item[0].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[0]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(
            item[1] !== undefined &&
            !(
              item[1].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[1]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[2] !== undefined &&
            !(
              item[2].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[2]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[3] !== undefined &&
            !(
              item[3].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[3]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[4] !== undefined &&
            !(
              item[4].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[4]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[5] !== undefined &&
            !(
              item[5].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[5]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[6] !== undefined &&
            !(
              item[6].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[6]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[7] !== undefined &&
            !(
              item[7].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[7]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[8] !== undefined &&
            !(
              item[8].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[8]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[9] !== undefined &&
            !(
              item[9].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            )
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[9]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[10] !== undefined &&
            !(
              item[10].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            ) && _vm.selectedKiosks.length <= 1
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[10]}}):_vm._e()],1),_c('v-col',{attrs:{"cols":"1"}},[(item[10] !== undefined &&
            !(
              item[11].handleMethod.split('handle')[1] == 'Debug' &&
              _vm.selectedKiosks.length > 1
            ) && _vm.selectedKiosks.length <= 1
          )?_c('JobDialogComponent',{attrs:{"selectedKiosks":_vm.selectedKiosks,"item":item[11]}}):_vm._e()],1)],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }